
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"107.608","height":"76.174"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 350","transform":"translate(2 2)","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"4"}},[_c('path',{attrs:{"data-name":"Path 577","d":"M7.911 72.174l15.134-19.227a5.392 5.392 0 018.484 0l15.13 19.227"}}),_c('path',{attrs:{"data-name":"Path 578","d":"M35.901 57.546l17.245-21.921a5.4 5.4 0 018.486 0l28.872 36.439"}}),_c('circle',{attrs:{"data-name":"Ellipse 34","cx":"6.977","cy":"6.977","r":"6.977","transform":"translate(13.31 20.609)","stroke-linecap":"round"}}),_c('path',{attrs:{"data-name":"Path 579","d":"M48.041 42.116a376.91 376.91 0 015.444 3.277l3.909-2.65 3.34 2.437 5.456-3.778","stroke-linecap":"round"}}),_c('rect',{attrs:{"data-name":"Rectangle 201","width":"93.743","height":"62.31","rx":"4.357","transform":"translate(0 9.864)","stroke-linecap":"round"}}),_c('path',{attrs:{"data-name":"Path 580","d":"M9.865 8.921V4.148A4.149 4.149 0 0114.012 0h85.444a4.15 4.15 0 014.151 4.148v54.011a4.15 4.15 0 01-4.151 4.15h-4.509","stroke-linecap":"round"}})])])
          )
        }
      }
    